/** RollTwice (Foundry: rule-element/roll-twice.ts): roll a selector's checks twice and keep the higher or lower (fortune or misfortune). */
import { resolveInjectedProperties } from "../resolve";
import type { EngineState } from "../state";
import type { RuleHandler, RuleInstance } from "./base";

interface RollTwiceData {
  selectors: string[];
  keep: "higher" | "lower";
  removeAfterRoll: boolean | null;
}

function parse(rule: RuleInstance): void {
  const s = rule.source;
  const raw = s.selector;
  const selectors = (Array.isArray(raw) ? raw : [raw]).filter((x): x is string => typeof x === "string" && x.length > 0);
  if (selectors.length === 0) return rule.fail("selector: must have at least 1");
  if (s.keep !== "higher" && s.keep !== "lower") return rule.fail(`keep: "${String(s.keep)}" is not higher or lower`);
  rule.data = { selectors, keep: s.keep, removeAfterRoll: typeof s.removeAfterRoll === "boolean" ? s.removeAfterRoll : null } satisfies RollTwiceData as unknown as Record<string, unknown>;
}

function beforePrepareData(rule: RuleInstance, state: EngineState): void {
  if (rule.ignored) return;
  const data = rule.data as unknown as RollTwiceData;
  const predicate = resolveInjectedProperties(rule, state, structuredClone(rule.predicate), { warn: false });
  for (const raw of data.selectors) {
    const selector = resolveInjectedProperties(rule, state, raw);
    if (rule.ignored) return;
    (state.synthetics.rollTwice[selector] ??= []).push({ keep: data.keep, predicate, parentOptions: rule.item.getRollOptions("parent"), source: rule.item.uuid, sourceName: rule.item.name, removeAfterRoll: data.removeAfterRoll === true });
  }
}

export const RollTwiceHandler: RuleHandler = { key: "RollTwice", parse, beforePrepareData };
